import ApplicationController from "application_controller.js";

export default class extends ApplicationController {

  debug = false;

  static values = {
    category: String,
    service: String,
    id: String,
    assetPath: String,
    assetType: String,
    tagAttributes: Object,
  };

  connect() {
    this.log_function("connect");
  }

  disconnect(){
    this.log_function("disconnect");
  }

  render(event){
    this.log_function("render");

    // TODO refactor to use cookiePolicy.acceptedService(this.serviceValue, this.categoryValue);

    const cookie = event.detail.cookie;

    const category_active = cookie.categories.includes(this.categoryValue);
    const service_defined = this.serviceValue !== "";
    const service_active = cookie.services[this.categoryValue].includes(this.serviceValue);

    this.log_function("render", `category:${this.categoryValue} is ${category_active}`);
    this.log_function("render", `service:${this.serviceValue} is ${service_active}`);

    if((category_active && !service_defined) || service_active){
      this.add_element_to_page();
    } else {
      this.remove_element_from_page();
    }
  }

  add_element_to_page(){
    this.log_function("add_element_to_page");

    if(!this.isElementOnPage) {
      this.element.insertAdjacentElement("afterend", this.createdElement);
    }
  }

  remove_element_from_page(){
    this.log_function("remove_element_from_page");

    if(this.isElementOnPage) {
      this.attachedElement.remove();
    }
  }

  get createdElement(){
    this.log_function("add_element_to_page");

    const tag = document.createElement(this.elementType);

    // * Merge defaultTagAttributes with tagAttributesValue to create allAttributes.
    // * defaultTagAttributes can be overwritten by incoming tagAttributesValue
    const allAttributes = {
      ...this.defaultTagAttributes,
      ...this.tagAttributesValue,
    };

    Object.entries(allAttributes).forEach(([key, value]) => {
      tag.setAttribute(key, value);
    });

    return tag;
  }

  get attachedElement(){
    return document.getElementById(this.idValue);
  }

  get isElementOnPage() {
    return !!this.attachedElement;
  }

  get elementType(){
    const ELEMENT_TYPES = {
      "css": "link",
      "javascript": "script",
    };

    return ELEMENT_TYPES[this.assetTypeValue] || "div";
  }

  get defaultTagAttributes(){
    const output = {};

    output["id"] = this.idValue;

    switch (this.assetTypeValue) {
      case "css":
        output["rel"] = "stylesheet";
        output["href"] = this.assetPathValue;
        break;
      case "javascript":
        output["type"] = "application/javascript";
        output["src"] = this.assetPathValue;
        break;
      default:
        this.log_error_function("defaultTagAttributes", `${this.assetTypeValue} is not a supported value`);
        break;
    }

    return output;
  }

}
